// extracted by mini-css-extract-plugin
module.exports = {"component":"Page_component__1pI4C","content":"Page_content__1KbVK","footer":"Page_footer__2GTfJ"};